import React from 'react';
import { DrawerNav, useDrawer } from '@thd-olt-component-react/drawer';
import './QuickViewNav.scss';

export const QuickViewNav = () => {
  const { setPreviousDrawer } = useDrawer();

  const goBack = (event) => {
    event.preventDefault();
    setPreviousDrawer();
  };
  return (
    <div className="quickview-nav">
      <DrawerNav>
        <a
          href="/"
          onClick={goBack}
          className="quickview-nav__back"
          data-testid="quickview-nav-link"
        >
          <img src="https://assets.homedepot-static.com/images/v1/caret-blue.svg" alt="Back" />
          Back to Quick View
        </a>
      </DrawerNav>
    </div>
  );
};